import { render, staticRenderFns } from "./fx-modal.vue?vue&type=template&id=71929ceb&scoped=true&"
import script from "./fx-modal.vue?vue&type=script&lang=js&"
export * from "./fx-modal.vue?vue&type=script&lang=js&"
import style0 from "./fx-modal.vue?vue&type=style&index=0&id=71929ceb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71929ceb",
  null
  
)

export default component.exports